import React, { FC, useMemo } from 'react';
import AccordionItem from './AccordionItem/AccordionItem';
import ServiceInfo from '../ServiceInfo/ServiceInfo';
import { IService } from '../../../../../interfaces/professional/Professional';

interface Props {
  items: Array<IService>;
  activeIds: Array<string>;
  action: (id: string) => void;
  itemAfterComponent?: JSX.Element;
}

const AccordionList: FC<Props> = ({ items, action, activeIds, itemAfterComponent }) => {
  const questionsRender = useMemo(() => {
    return items.map(item => {
      const specialties = [...item.specialties.map(item => item.title), ...item.customSpecialties];
      const benefits = [...item.helps.map(item => item.title), ...item.customHelps];
      // if (item.sector?.benefits?.length) {
      //   benefits = [...benefits, ...item.sector.benefits];
      // }
      return (
        <AccordionItem
          key={item.id}
          id={item.id}
          title={item?.sector?.title || item.customSector}
          description={
            <ServiceInfo
              specialties={specialties}
              helps={benefits}
              appointmentTypes={item.appointmentTypes.concat(
                item.customAppointmentTypes.map((item, index) => ({ title: item, id: index.toString() })),
              )}
              year={item.experience.year}
            />
          }
          action={action}
          isActive={activeIds?.some(activeId => activeId === item.id)}
          afterComponent={itemAfterComponent}
        />
      );
    });
  }, [action, activeIds, itemAfterComponent, items]);

  return <>{questionsRender}</>;
};

export default AccordionList;
